export default __webpack_public_path__ + "static/media/cs-logo.7d24eab8.jpg";